'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndPlanYearReview } from '../../Entities/Ind/IndPlanYearReview';
import { IndPlanYearReviewCollection } from '../../Collections/Ind/IndPlanYearReviewCollection';

export class IndPlanYearReviewRepository extends CoreRepository {
  public createIndPlanYearReview(indId: number, payload: any[]) {
    return this.webAPI.createIndPlanYearReview(indId, payload).then((response) => {
      const indPlanYearReview = new IndPlanYearReview();
      indPlanYearReview.hydrate(response);

      return indPlanYearReview;
    });
  }

  public removeIndPlanYearReview(indId: number, indPlanYearReviewId: number) {
    return this.webAPI.removeIndPlanYearReview(indId, indPlanYearReviewId).then((response) => {
      return response;
    });
  }
}
